export const cooktop_url: string = "cooktop";